<template>
    <div class="flex-table-main">
        <div class="flex-table xc-table-linkage">
            <div class="xc-table-linkage-thead">
                <slot name="flex-table-thead">

                </slot>
                <!-- <div class="xc-table-linkage-tr">
                    <div class="xc-table-thead-item" style="padding-left:40px">通道ID</div>
                    <div class="xc-table-thead-item">通道名称</div>
                </div> -->
            </div>
            <div class="xc-table-linkage-tbody">
                <slot name="flex-table-box"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'flex-table'
}
</script>

<style lang="less">
    .flex-table-main{
        .xc-table-linkage{
            border-bottom: 1px solid #E3E8EE;
    
            
            .xc-table-linkage-thead{
                
                border-top: 1px solid #E3E8EE;
                border-bottom:none;
                // border-bottom: 1px solid #E3E8EE;
                background-color: #f5f7f9;
                font-weight: bold;
                
                .xc-table-linkage-tr{
                    display: flex;
                    justify-content: space-between;
                    height: 48px;
                    align-items: center;
                    color: #464C5B;
                    font-size: 14px;
    
                    .xc-table-thead-item{
                        padding: 0 8px;
                        flex: 1;
                        align-items: center;
                        text-align: left;
                    }
                    
                }
                &:last-child{
                    border-bottom:none;
                }
            }
            .xc-table-linkage-tbody{
                
                .xc-table-linkage-box{
                    border-top: 1px solid #E3E8EE;
                    border-bottom:none;
                    .xc-table-linkage-tr{
                        position: relative;
                    }
                    .table-icon{
                        width: 16px !important;
                        height: 16px !important;
                        // position: absolute;
                        // top:50%;
                        // left: 24px;
                        // margin-top: -8px;
                        vertical-align: middle;
                        cursor: pointer;
                    }
                    &:last-child{
                        border-bottom:none;
                    }
                }
                .xc-table-linkage-tr{
                    display: flex;
                    justify-content: space-between;
                    height: 64px;
                    align-items: center;
                    color: #464C5B;
                    font-size: 14px;
    
                    .xc-table-tbody-item{
                        padding: 0 8px;
                        flex: 1;
                        align-items: center;
                        text-align: left;
                        word-break: break-word;

                        .td-label{
                            display: -webkit-box;
                            word-break: break-word;
                            text-overflow:ellipsis;
                            overflow: hidden;
                            white-space: pre-line;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp:2;
                        }
                    }
                    
                }
    
                .xc-secondary-table{
                    
                    .xc-secondary-thead{
                        background-color: #f5f7f9;
                        font-weight: bold;
    
                        .xc-secondary-tr{
                            display: flex;
                            justify-content: space-between;
                            min-height: 64px;
                            align-items: center;
                            color: #464C5B;
                            font-size: 14px;
                            border-bottom: 1px solid #E3E8EE;
    
    
                            .xc-secondary-table-item{
                                flex: 1;
                                text-align: center;
                            }
                        }
                    }
    
                    .xc-secondary-tbody{
                        .xc-secondary-tr{
                            display: flex;
                            justify-content: space-between;
                            min-height: 64px;
                            align-items: center;
                            color: #464C5B;
                            font-size: 14px;
                            border-bottom: 1px solid #E3E8EE;
                            background-color: #f5f7f9;
    
                            .xc-secondary-tbody-item{
                                flex: 1;
                                text-align: left;
                                margin-left: 120px;
                                word-break: break-all;
    
                            }
                            &:last-child{
                                border-bottom: none;
                            }
                        }
                    }
                }
            }
        }
    }
</style>